// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrainingCertificateDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';
import { map } from 'rxjs';

@Injectable()
export class TrainingCertificateApiClient extends BaseCRUDApiClient<TrainingCertificateDto> {
  baseUrl = this.config.apiEndpoint + '/training-certificate';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  createDocument(id: string) {
    return this.http
      .post(
        `${this.baseUrl}/create-document`,
        { id: id },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveAndAttachDocument(id: string) {
    return this.http.post(`${this.baseUrl}/save-and-attach-document`, {
      id: id,
    });
  }
}
